/**
 * Generation module permissions (AB#955377, D4, D21). These are created in BeeHive
 * later by the owner (work-plan I-13); until then the shell's fake/dev auth and
 * component tests supply them.
 *
 * The three permissions form a hierarchy (D21): each tier implies the one below.
 *
 *  - `generation.admin`  implies `generation.review` and `generation.access`.
 *    Sees the module, reads and decides reviews, publishes, regenerates.
 *  - `generation.review` implies `generation.access`.
 *    Sees the module, reads the queue and decides (approve/reject).
 *  - `generation.access` sees the module only.
 *
 * Every guard asks the helpers below, never a single permission string, so the
 * hierarchy lives in exactly one place. Each helper takes the user's effective
 * permission set.
 */
export const GENERATION_ACCESS = "generation.access";
export const GENERATION_REVIEW = "generation.review";
export const GENERATION_ADMIN = "generation.admin";

/** `generation.access`, `.review` or `.admin` — may see the module. */
export function canAccess(perms: ReadonlySet<string>): boolean {
  return (
    perms.has(GENERATION_ACCESS) ||
    perms.has(GENERATION_REVIEW) ||
    perms.has(GENERATION_ADMIN)
  );
}

/** `generation.review` or `.admin` — may read the queue and decide. */
export function canReview(perms: ReadonlySet<string>): boolean {
  // TEMPORARY (owner, 2026-11-04): generation.access grants everything until the BeeHive roles are fixed.
  // return perms.has(GENERATION_REVIEW) || perms.has(GENERATION_ADMIN);
  return canAccess(perms);
}

/** `generation.admin` only — may publish and regenerate. */
export function canAdmin(perms: ReadonlySet<string>): boolean {
  // TEMPORARY (owner, 2026-11-04): generation.access grants everything until the BeeHive roles are fixed.
  // return perms.has(GENERATION_ADMIN);
  return canAccess(perms);
}
